import { Container } from "@mui/material";

export const TermsAndConditions = () => {
  return (
    <Container style={{ marginTop: "2rem" }}>
      <h1 className="nhsuk-heading-xl">Terms and Conditions</h1>
      <p className="nhsuk-body">
        These terms and conditions (the "Terms and Conditions") govern the use
        of www.mentalhealthonline.co.uk (the "Site"). This Site is owned and
        operated by Red Star AI Ltd. This Site is a a pilot system to collect
        data from patients and relatives to support assessment and monitoring
        for mental health and neurodevelopmental conditions.
      </p>

      <p className="nhsuk-body">
        <strong>
          The site SHOULD NOT BE USED to communicate in relation to ISSUES WHICH
          ARE IMPORTANT TO CLINICAL CARE OR PATIENT SAFETY or which would have a
          detrimental impact on the Patient or anyone else if the message or
          content was not received or if there was a delay in healthcare staff
          receiving the message or in acting upon it.
        </strong>
      </p>

      <p className="nhsuk-body">
        <strong>
          UNDER NO CIRCUMSTANCES DO RED STAR AI LTD ACCEPT ANY LIABILITIES FOR
          ISSUES WHICH ARISE FROM FAILURES OR DELAYS IN COMMUNICATION OF ANY
          INFORMATION, IN PARTICULAR THAT RELATED TO CLINICAL CARE OR PATIENT
          SAFETY.
        </strong>
      </p>

      <p className="nhsuk-body">
        By using this Site, you indicate that you have read and understand these
        Terms and Conditions and agree to abide by them at all times.
      </p>

      <p className="nhsuk-body">
        THESE TERMS AND CONDITIONS CONTAIN A DISPUTE RESOLUTION CLAUSE THAT
        IMPACTS YOUR RIGHTS ABOUT HOW TO RESOLVE DISPUTES. PLEASE READ IT
        CAREFULLY.
      </p>

      <h2 className="nhsuk-heading-m">Intellectual Property</h2>
      <p className="nhsuk-body">
        All content published and made available on our Site is the property of
        Red Star AI Ltd and the Site's creators. This includes, but is not
        limited to images, text, logos, documents, downloadable files and
        anything that contributes to the composition of our Site.
      </p>

      <h2 className="nhsuk-heading-m">Age Restrictions</h2>
      <p className="nhsuk-body">
        The minimum age to use our Site is 16 years old. By using this Site,
        users agree that they are over 16 years old. We do not assume any legal
        responsibility for false statements about age.
      </p>

      <h2 className="nhsuk-heading-m">Acceptable Use</h2>
      <p className="nhsuk-body">
        As a user of our Site, you agree to use our Site legally, not to use our
        Site for illegal purposes, and not to:
      </p>
      <ul>
        <li>Harass or mistreat other users of our Site;</li>
        <li>Violate the rights of other users of our Site;</li>
        <li>
          Violate the intellectual property rights of the Site owners or any
          third party to the Site;
        </li>
        <li>
          Hack into the account of another user of the Site (or attempt to do
          so);
        </li>
        <li>Act in any way that could be considered fraudulent;</li>
        <li>
          Post any material that may be deemed inappropriate or offensive;
        </li>
        <li>
          Circumvent, disable or interfere with the security features of the
          website (or attempt to do so);
        </li>
        <li>
          Upload or transmit (or attempt to do so) any virus, Trojan horse or
          other code or actions which risk compromising the security or service
          of the site;
        </li>
        <li>
          Share your url (i.e. the website link), password or other login
          details with anyone else;
        </li>
        <li>
          Post any messages likely to cause distress to any other user including
          NHS staff;
        </li>
        <li>Submit repeated or vexatious requests; or</li>
        <li>
          Add details or relatives, partners or other contacts without having
          their consent to do so.
        </li>
        <li>
          Add any other user to the site where you suspect the other user may
          violate these Terms and Conditions including this Acceptable Use
          policy
        </li>
      </ul>

      <p className="nhsuk-body">
        If we believe you are using our Site illegally or in a manner that
        violates these Terms and Conditions, we reserve the right to limit,
        suspend or terminate your access to our Site. We also reserve the right
        to take any legal steps necessary to prevent you from accessing our
        Site.
      </p>

      <p className="nhsuk=body">
        IF YOU BELIEVE, OR SHOULD HAVE A REASONABLE BELIEF, THAT YOU HAVE
        RECEIVED LOGIN CREDENTIALS OR ACCESS TO INFORMATION THAT YOU SHOULD NOT
        BE ALLOWED TO VIEW, YOU MUST IMMEDIATELY STOP USING THE SITE, AVOID
        LOGGING INTO THE SITE, AND CONTACT support@redstar.ai TO MAKE THEM AWARE
        OF THIS.
      </p>

      <h2 className="nhsuk-heading-m">User Contributions</h2>
      <p className="nhsuk-body">
        Users may post the following information on our Site:
      </p>
      <ul>
        <li>Eating Disorders: Answers to psychological questionnaires;</li>
        <li>Eating Disorders: Food diaries;</li>
        <li>ADHD: Answers to assessment questionnaires;</li>
        <li>ADHD: Answers to medical monitoring questions;</li>
        <li>Communications with healthcare workers; and</li>
        <li>Any other content which may be posted through the Site.</li>
        <li>
          By posting on our Site, you agree not to act illegally or violate
          these Terms and Conditions.
        </li>
      </ul>

      <h2 className="nhsuk-heading-m">Accounts</h2>
      <p className="nhsuk-body">
        When you create an account on our Site, you agree to the following:
      </p>

      <ol>
        <li>
          You are solely responsible for your account and the security and
          privacy of your account, including passwords or sensitive information
          attached to that account; and
        </li>
        <li>
          All personal information you provide to us through your account is up
          to date, accurate, and truthful and that you will update your personal
          information if it changes.
        </li>
      </ol>

      <p className="nhsuk-body">
        We reserve the right to suspend or terminate your account if you are
        using our Site illegally or if you violate these Terms and Conditions
      </p>

      <h2 className="nhsuk-heading-m">Links to Other Websites</h2>
      <p className="nhsuk-body">
        Our Site contains links to third party websites or services that we do
        not own or control. We are not responsible for the content, policies, or
        practices of any third party website or service linked to on our Site.
        It is your responsibility to read the terms and conditions and privacy
        policies of these third party websites before using these sites.{" "}
      </p>

      <h2 className="nhsuk-heading-m">Limitation of Liability</h2>
      <p className="nhsuk-body">
        Red Star AI Ltd and our directors, officers, agents, employees,
        subsidiaries, and affiliates will not be liable for any actions, claims,
        losses, damages, liabilities and expenses including legal fees from your
        use of the Site or from any consequent action including that which
        relates to other users of the site who may be Patients, hospital staff
        or relatives and contacts of Patients.
      </p>
      <p className="nhsuk-body">
        Red Star AI Ltd and our directors, officers, agents, employees,
        subsidiaries, subcontractors and affiliates will not be liable for any
        actions, claims, losses, damages, liabilities and expenses including
        legal fees or any harm you may suffer which is due to the actions of
        other users of the Site, or Third Parties, or any failure of the Site to
        provide a service. This is a pilot project to evaluate the service and
        technology. It is free to use for patients, relatives and contacts and
        is provided as-is with no warranty
      </p>

      <p className="nhsuk-body">
        We are not responsible for the accuracy or timely delivery of
        information you find on our site including content generated by yourself
        or other users.
      </p>

      <h2 className="nhsuk-heading-m">Indemnity</h2>
      <p className="nhsuk-body">
        Except where prohibited by law, by using this Site you indemnify and
        hold harmless Red Star AI Ltd and our directors, officers, agents,
        employees, subsidiaries, subcontractors and affiliates from any actions,
        claims, losses, damages, liabilities and expenses including legal fees
        arising out of other users you add to our site.
      </p>

      <h2 className="nhsuk-heading-m">Applicable Law</h2>
      <p className="nhsuk-body">
        These Terms and Conditions are governed by the laws of the Country of
        Scotland.{" "}
      </p>

      <h2 className="nhsuk-heading-m">Dispute Resolution</h2>
      <p className="nhsuk-body">
        Subject to any exceptions specified in these Terms and Conditions, if
        you and Red Star AI Ltd are unable to resolve any dispute through
        informal discussion, then you and Red Star AI Ltd agree to submit the
        issue first before a non-binding mediator and to an arbitrator in the
        event that mediation fails. The decision of the arbitrator will be final
        and binding. Any mediator or arbitrator must be a neutral party
        acceptable to both you and Red Star AI Ltd. Notwithstanding any other
        provision in these Terms and Conditions, you and Red Star AI Ltd agree
        that you both retain the right to bring an action in small claims court
        and to bring an action for injunctive relief or intellectual property
        infringement.
      </p>

      <h2 className="nhsuk-heading-m">Severability</h2>
      <p className="nhsuk-body">
        If at any time any of the provisions set forth in these Terms and
        Conditions are found to be inconsistent or invalid under applicable
        laws, those provisions will be deemed void and will be removed from
        these Terms and Conditions. All other provisions will not be affected by
        the removal and the rest of these Terms and Conditions will still be
        considered valid.{" "}
      </p>

      <h2 className="nhsuk-heading-m">Changes</h2>
      <p className="nhsuk-body">
        These Terms and Conditions may be amended from time to time in order to
        maintain compliance with the law and to reflect any changes to the way
        we operate our Site and the way we expect users to behave on our Site.
        We will notify users by email of changes to these Terms and Conditions
        or post a notice on our Site
      </p>

      <h2 className="nhsuk-heading-m">Contact Details</h2>
      <p className="nhsuk-body">
        Please contact us if you have any questions or concerns. Our contact
        details are as follows:
        <br />
        support@redstar.ai
      </p>
    </Container>
  );
};
